import React, { useState } from 'react';
import './VideoDemo.css';
import { Play, ExternalLink } from 'lucide-react';

function VideoDemo() {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <section className='video-demo' id='video-demo'>
      <div className='video-demo-container'>
        <div className='video-demo-header'>
          <div className='demo-badge shimmer'>
            <Play size={16} />
            <span>Watch Demo</span>
          </div>
          <h2 className='video-demo-title'>See the Magic in 90 Seconds</h2>
          <p className='video-demo-subtitle'>
            Watch how one newsletter transforms into 6+ platform-ready posts in
            90 seconds
          </p>
        </div>

        <div className='video-wrapper'>
          {!isPlaying ? (
            <div className='video-thumbnail' onClick={() => setIsPlaying(true)}>
              <div className='play-button'>
                <div className='play-pulse'></div>
                <Play size={40} fill='white' />
              </div>
              <div className='video-overlay'>
                <span className='video-duration'>0:58</span>
              </div>
            </div>
          ) : (
            <div className='video-container'>
              {/* <iframe
                width='100%'
                height='100%'
                src='https://www.youtube.com/watch?v=KhzmUrt_3dY'
                title='Repost Demo'
                frameBorder='0'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                allowFullScreen
                style={{ borderRadius: '16px' }}
              /> */}
              <iframe
                width='100%'
                height='100%'
                src='https://www.youtube.com/embed/KhzmUrt_3dY?si=8szc3VD_qGEgaHxC?rel=0'
                title='YouTube video player'
                frameborder='0'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                referrerpolicy='strict-origin-when-cross-origin'
                allowfullscreen
              />
            </div>
          )}
        </div>

        {/* <div className='video-cta'>
          <a
            href='YOUR_MVP_URL'
            target='_blank'
            rel='noopener noreferrer'
            className='try-live-btn'
          >
            Try Live Demo
            <ExternalLink size={18} />
          </a>
        </div> */}
      </div>
    </section>
  );
}

export default VideoDemo;
